export const SVG_Pro = (
  <svg
    width='388'
    height='332'
    viewBox='0 0 388 332'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M350.271 181H337.729C337.327 181 337 180.715 337 180.362V179.637C337 179.286 337.327 179 337.729 179H350.271C350.672 179 351 179.286 351 179.637V180.362C351 180.715 350.672 181 350.271 181Z'
      fill='#E8E6E1'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M262 184C262 184 262.496 200 281.5 200C300.504 200 301 184 301 184H262Z'
      fill='#DAD9D3'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M215 163H244V157H215V163Z'
      fill='#D3D1CB'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M103.334 184H81.6665C80.2001 184 79 182.875 79 181.5C79 180.124 80.2001 179 81.6665 179H103.334C104.8 179 106 180.124 106 181.5C106 182.875 104.8 184 103.334 184Z'
      fill='#E8E6E1'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M103.334 138H81.6665C80.2001 138 79 136.875 79 135.5C79 134.124 80.2001 133 81.6665 133H103.334C104.8 133 106 134.124 106 135.5C106 136.875 104.8 138 103.334 138Z'
      fill='#E8E6E1'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M103.334 230H81.6665C80.2001 230 79 228.876 79 227.5C79 226.126 80.2001 225 81.6665 225H103.334C104.8 225 106 226.126 106 227.5C106 228.876 104.8 230 103.334 230Z'
      fill='#E8E6E1'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M388 320.501C388 326.852 301.143 332 194 332C86.8567 332 0 326.852 0 320.501C0 314.149 86.8567 309 194 309C301.143 309 388 314.149 388 320.501Z'
      fill='#E3ECFA'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M363.619 95H265.381C260.222 95 256 90.8233 256 85.7192V59.2808C256 54.1767 260.222 50 265.381 50H363.619C368.779 50 373 54.1767 373 59.2808V85.7192C373 90.8233 368.779 95 363.619 95Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M344.354 63H267.646C266.741 63 266 62.2718 266 61.3822V59.6178C266 58.7282 266.741 58 267.646 58H344.354C345.259 58 346 58.7282 346 59.6178V61.3822C346 62.2718 345.259 63 344.354 63Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M320.345 75H267.655C266.745 75 266 74.2718 266 73.3822V71.6168C266 70.7272 266.745 70 267.655 70H320.345C321.256 70 322 70.7272 322 71.6168V73.3822C322 74.2718 321.256 75 320.345 75Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M306.34 87H267.66C266.747 87 266 86.2728 266 85.3822V83.6178C266 82.7282 266.747 82 267.66 82H306.34C307.253 82 308 82.7282 308 83.6178V85.3822C308 86.2728 307.253 87 306.34 87Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M353.341 87H314.66C313.747 87 313 86.2728 313 85.3822V83.6178C313 82.7282 313.747 82 314.66 82H353.341C354.254 82 355 82.7282 355 83.6178V85.3822C355 86.2728 354.254 87 353.341 87Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M343.372 63H309.421C309.003 61.3281 308.529 59.6591 308 58H343.372C344.267 58 345 58.7282 345 59.6178V61.3822C345 62.2718 344.267 63 343.372 63Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M319.392 75H311.618C311.465 73.332 311.258 71.665 311 70H319.392C320.277 70 321 70.7272 321 71.6168V73.3822C321 74.2718 320.277 75 319.392 75Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M353.341 87H314.66C313.747 87 313 86.2728 313 85.3822V83.6178C313 82.7282 313.747 82 314.66 82H353.341C354.254 82 355 82.7282 355 83.6178V85.3822C355 86.2728 354.254 87 353.341 87Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M285.248 107H173.752C166.189 107 160 100.783 160 93.1819V53.8181C160 46.2174 166.189 40 173.752 40H285.248C292.811 40 299 46.2174 299 53.8181V93.1819C299 100.783 292.811 107 285.248 107Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M288.593 58H176.407C175.084 58 174 56.9804 174 55.7353V53.2647C174 52.0187 175.084 51 176.407 51H288.593C289.917 51 291 52.0187 291 53.2647V55.7353C291 56.9804 289.917 58 288.593 58Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M253.578 76H176.423C175.091 76 174 74.9813 174 73.7362V71.2647C174 70.0196 175.091 69 176.423 69H253.578C254.91 69 256 70.0196 256 71.2647V73.7362C256 74.9813 254.91 76 253.578 76Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M232.589 94H176.411C175.085 94 174 92.9813 174 91.7353V89.2647C174 88.0196 175.085 87 176.411 87H232.589C233.917 87 235 88.0196 235 89.2647V91.7353C235 92.9813 233.917 94 232.589 94Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M293.572 94H246.428C245.092 94 244 92.9813 244 91.7353V89.2647C244 88.0196 245.092 87 246.428 87H293.572C294.907 87 296 88.0196 296 89.2647V91.7353C296 92.9813 294.907 94 293.572 94Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M215.626 211H162.373C158.868 211 156 208.116 156 204.592V124.408C156 120.885 158.868 118 162.373 118H215.626C219.133 118 222 120.885 222 124.408V204.592C222 208.116 219.133 211 215.626 211Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M215.626 212H162.373C158.868 212 156 209.094 156 205.543V130.424C157.235 129.622 158.468 128.815 159.698 128C161.976 131.583 164.492 134.937 167.215 138.056H164.816C164.169 138.056 163.64 138.593 163.64 139.248V141.016C163.64 141.672 164.169 142.207 164.816 142.207H171.099C173.18 144.284 175.36 146.237 177.626 148.06H164.816C164.169 148.06 163.64 148.595 163.64 149.251V151.02C163.64 151.675 164.169 152.211 164.816 152.211H183.259C186.525 154.41 189.929 156.362 193.451 158.063H189.971C189.324 158.063 188.795 158.599 188.795 159.254V161.023C188.795 161.678 189.324 162.213 189.971 162.213H203.779C209.677 164.132 215.793 165.383 222 165.922V205.543C222 207.56 221.075 209.369 219.632 210.556C218.536 211.458 217.141 212 215.626 212Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M213.817 132H165.182C164.532 132 164 131.483 164 130.852V129.149C164 128.517 164.532 128 165.182 128H213.817C214.468 128 215 128.517 215 129.149V130.852C215 131.483 214.468 132 213.817 132Z'
      fill='#F8F6F4'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M198.802 142H165.198C164.539 142 164 141.484 164 140.852V139.149C164 138.518 164.539 138 165.198 138H198.802C199.461 138 200 138.518 200 139.149V140.852C200 141.484 199.461 142 198.802 142Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M213.817 152H165.182C164.532 152 164 151.483 164 150.852V149.148C164 148.516 164.532 148 165.182 148H213.817C214.468 148 215 148.516 215 149.148V150.852C215 151.483 214.468 152 213.817 152Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M182.843 162H165.157C164.521 162 164 161.483 164 160.852V159.148C164 158.517 164.521 158 165.157 158H182.843C183.479 158 184 158.517 184 159.148V160.852C184 161.483 183.479 162 182.843 162Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M207.843 162H190.157C189.521 162 189 161.484 189 160.853V159.148C189 158.517 189.521 158 190.157 158H207.843C208.479 158 209 158.517 209 159.148V160.853C209 161.484 208.479 162 207.843 162Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M213.817 172H165.182C164.532 172 164 171.484 164 170.852V169.148C164 168.517 164.532 168 165.182 168H213.817C214.468 168 215 168.517 215 169.148V170.852C215 171.484 214.468 172 213.817 172Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M213.817 182H165.182C164.532 182 164 181.483 164 180.852V179.149C164 178.517 164.532 178 165.182 178H213.817C214.468 178 215 178.517 215 179.149V180.852C215 181.483 214.468 182 213.817 182Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M204.828 192H165.172C164.527 192 164 191.483 164 190.852V189.148C164 188.517 164.527 188 165.172 188H204.828C205.473 188 206 188.517 206 189.148V190.852C206 191.483 205.473 192 204.828 192Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M183.819 202H165.181C164.532 202 164 201.483 164 200.851V199.148C164 198.517 164.532 198 165.181 198H183.819C184.468 198 185 198.517 185 199.148V200.851C185 201.483 184.468 202 183.819 202Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M230.127 118H156L188.74 144.087L239 163V126.876C239 121.994 235.009 118 230.127 118Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M226.531 137H172.468C171.66 137 171 136.303 171 135.451V132.549C171 131.697 171.66 131 172.468 131H226.531C227.34 131 228 131.697 228 132.549V135.451C228 136.303 227.34 137 226.531 137Z'
      fill='#F8F6F4'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M254 188.722V136.279C254 132.276 257.255 129 261.234 129H351.765C355.744 129 359 132.276 359 136.279V188.722C359 192.726 355.744 196 351.765 196H261.234C257.255 196 254 192.726 254 188.722Z'
      fill='#6D5DD3'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M270 171.722V119.279C270 115.275 273.256 112 277.235 112H367.767C371.746 112 375 115.275 375 119.279V171.722C375 175.726 371.746 179 367.767 179H277.235C273.256 179 270 175.726 270 171.722Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M368.146 178.835H300.458C300.655 176.26 300.862 173.894 301.052 171.711H321.904C323.268 171.711 324.384 170.596 324.384 169.232V144.551C324.384 143.187 323.268 142.072 321.904 142.072H309.473C310.111 141.359 310.732 140.616 311.338 139.839C312.586 138.133 313.792 136.282 314.548 133.914C314.919 132.734 315.175 131.392 315.093 129.905C315.048 129.165 314.906 128.395 314.657 127.644C314.532 127.269 314.382 126.9 314.206 126.544L313.834 125.817C312.003 122.247 309.928 118.797 307.558 115.558C307.077 114.893 306.59 114.233 306.093 113.579C306.305 113.054 306.51 112.529 306.711 112H368.146C372.139 112 375.405 115.267 375.405 119.261V171.575C375.405 175.569 372.139 178.835 368.146 178.835ZM330.034 153.657C330.034 155.436 331.49 156.892 333.27 156.892H362.953C364.732 156.892 366.188 155.436 366.188 153.657V121.458C366.188 119.679 364.732 118.223 362.953 118.223H333.27C331.49 118.223 330.034 119.679 330.034 121.458V153.657ZM296.925 143.463C296.847 143.368 296.696 143.313 296.525 143.313C296.49 143.313 296.455 143.315 296.419 143.32L296.38 143.325C295.786 139.802 295.304 136.58 295 133.043C297.821 129.358 300.316 125.456 302.468 121.386C304.344 123.908 306.105 126.517 307.748 129.2L308.077 129.734L308.204 129.955C308.279 130.11 308.338 130.289 308.378 130.507C308.465 130.94 308.455 131.537 308.315 132.209C308.032 133.558 307.362 135.128 306.497 136.628C305.655 138.157 304.633 139.667 303.521 141.13C303.288 141.444 303.05 141.758 302.807 142.072H299.152C298.178 142.072 297.33 142.641 296.925 143.463Z'
      fill='#DE92EB'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M330 154.737V122.263C330 120.468 331.45 119 333.222 119H362.779C364.55 119 366 120.468 366 122.263V154.737C366 156.532 364.55 158 362.779 158H333.222C331.45 158 330 156.532 330 154.737Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M362.779 158H333.222C331.45 158 330 156.532 330 154.737V122.263C330 120.468 331.45 119 333.222 119H362.779C364.55 119 366 120.468 366 122.263V154.737C366 156.532 364.55 158 362.779 158Z'
      fill='#FCEDFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M297 170.491V145.509C297 144.129 298.128 143 299.506 143H322.494C323.872 143 325 144.129 325 145.509V170.491C325 171.871 323.872 173 322.494 173H299.506C298.128 173 297 171.871 297 170.491Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M321.979 172.639H301.127C302.041 162.122 302.572 155.822 299.836 150.479C300.755 150.245 301.788 149.857 302.606 149.218L302.608 149.221C305.147 147.375 307.44 145.352 309.548 143H321.979C323.343 143 324.459 144.115 324.459 145.479V170.16C324.459 171.524 323.343 172.639 321.979 172.639ZM300.871 145.475L297.346 144.898L297.016 144.411C297.011 144.404 297.006 144.397 297 144.391C297.405 143.569 298.253 143 299.227 143H302.882C302.232 143.839 301.551 144.671 300.871 145.475Z'
      fill='#FCEDFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M194 26H264V16H194V26Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M74 98.9306C73.1406 100.9 72.184 103.102 71.3491 105.229C70.5054 107.379 69.6587 109.529 68.9042 111.698C67.3571 116.021 66.0395 120.401 65.185 124.696L64.8995 126.299L64.7994 126.908C64.769 127.073 64.766 127.301 64.7425 127.495C64.6974 128.347 64.716 129.378 64.8033 130.434C64.9878 132.557 65.3194 134.825 65.7383 137.1C66.5663 141.651 67.6171 146.347 68.657 150.962L63.6241 153C61.2763 148.59 59.2945 144.115 57.6443 139.335C56.833 136.942 56.0923 134.493 55.5703 131.835C55.3113 130.5 55.0768 129.121 55.017 127.553C55.0111 127.144 54.9895 126.766 55.0062 126.328C55.0219 125.901 55.0405 125.42 55.0759 125.133L55.2682 123.144C55.5723 120.518 56.0275 117.946 56.6152 115.454C57.1675 112.942 57.8749 110.503 58.6254 108.091C59.3848 105.679 60.2216 103.31 61.1498 100.981C61.6099 99.813 62.0896 98.6562 62.5861 97.5014C63.0815 96.3256 63.5858 95.2382 64.1921 94L74 98.9306Z'
      fill='#ED975D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M68.9562 149L73 152.922L64.1829 157C64.1829 157 62.0429 153.286 63.5197 149.927L68.9562 149Z'
      fill='#E6776F'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M76 158.925L68.5998 162L64 157.137L72.7629 153L76 158.925Z'
      fill='#E6776F'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M239.211 147V126.231C239.211 121.988 236.099 118.423 232 117.617L237.901 113H252.389C251.151 116.274 250.374 119.311 250.374 119.311L253 120.563C252.662 121.462 252.329 122.364 252.003 123.272C250.647 126.999 249.386 130.761 248.352 134.687C248.219 135.173 248.097 135.671 247.98 136.173L247.802 136.924L247.707 137.333C247.67 137.526 247.628 137.717 247.601 137.915C247.345 139.495 247.631 141.246 248.304 142.616C248.673 143.36 249.094 144.008 249.551 144.581C246.138 145.672 242.679 146.475 239.211 147Z'
      fill='#FEFCFB'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M255.292 106.959H246L247.098 106.041H256C255.76 106.308 255.523 106.617 255.292 106.959Z'
      fill='#F8F6F4'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M256.312 106.231H247L262.042 94.213H273.201C274.131 97.159 274.081 100.146 269.905 101.74C266.281 102.554 262.393 103.731 259.978 104.502C259.256 104.671 258.47 104.935 257.594 105.286C257.158 105.461 256.73 105.789 256.312 106.231ZM283.608 99.946C282.178 98.9 281.471 96.725 281.153 94.213H293.398C293.649 94.213 293.891 94.174 294.119 94.102C293.788 96.007 293.372 97.896 292.875 99.76C291.963 99.731 290.925 99.711 289.808 99.711C287.897 99.711 285.754 99.77 283.608 99.946ZM294.939 87.325C294.521 86.975 293.983 86.764 293.398 86.764H281.022C281.081 85.623 281.155 84.574 281.21 83.7L278.419 86.764H271.366L293.6 69C294.605 73.609 295.093 78.261 295.092 82.88C295.092 84.365 295.04 85.849 294.939 87.325Z'
      fill='#66A4FF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M293.356 94.449H281.111C280.807 92.044 280.861 89.329 280.98 87H293.356C293.941 87 294.479 87.211 294.897 87.561C294.742 89.839 294.467 92.099 294.077 94.338C293.849 94.41 293.607 94.449 293.356 94.449ZM273.159 94.449H262L271.324 87H278.377L272.717 93.213C272.878 93.622 273.028 94.035 273.159 94.449Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M229.976 149C220.271 149 210.716 146.84 202 142.755L208.771 137.31H227.749C228.57 137.31 229.24 136.635 229.24 135.81V133.001C229.24 132.176 228.57 131.501 227.749 131.501H215.995L232.783 118C236.885 118.829 240 122.497 240 126.861V148.226C236.659 148.745 233.31 149 229.976 149Z'
      fill='#66A4FF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M226.543 137H208L215.059 131H226.543C227.345 131 228 131.697 228 132.549V135.451C228 136.303 227.345 137 226.543 137Z'
      fill='#F8F6F4'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M180.527 117.507H173.375C172.205 115.639 171.12 113.697 170.124 111.679C169.732 110.885 169.357 110.086 169 109.284L173.109 106C173.187 106.002 173.265 106.002 173.343 106.002H185.952V113.173L180.527 117.507ZM186.202 112.973V106.002H194.926L186.202 112.973Z'
      fill='#FEFCFB'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M186.375 113V106H186.625V112.805L186.375 113Z'
      fill='#E0DED8'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M278 39H277V38C277.338 38.3294 277.67 38.6619 278 39Z'
      fill='#EEEBE7'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M195.817 106.597H174.234C174.156 106.597 174.078 106.597 174 106.595L189.038 94.579H210.858L195.817 106.597ZM220.18 87.13H198.361L211.503 76.629H233.323L220.18 87.13ZM242.645 69.18H220.825L233.967 58.68H255.787L242.645 69.18ZM265.109 51.231H243.289L257.345 40H279.01C279.031 40.024 279.053 40.049 279.074 40.073L265.109 51.231Z'
      fill='#66A4FF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M254.721 58H233L242.279 51H264L254.721 58Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M232.721 76H211L220.279 69H242L232.721 76Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M210.721 94H189L198.28 87H220L210.721 94Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M176.451 122C175.598 120.708 174.779 119.371 174 118H181L176.451 122Z'
      fill='#66A4FF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M186.625 39H186.375V33.1992C186.458 33.1325 186.541 33.0658 186.625 33V39Z'
      fill='#E0DED8'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M198.375 39H198.625V25H198.375V39Z'
      fill='#E0DED8'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M237 27V25H239L237 27Z'
      fill='#F8F6F4'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M164.042 86C164.014 85.2061 164 84.4112 164 83.6193C164.006 67.6425 169.77 52.0677 180.256 40H221L206.989 51.3151H176.919C175.599 51.3151 174.517 52.4072 174.517 53.7432V56.3919C174.517 57.7268 175.599 58.8199 176.919 58.8199H197.697L184.598 69.3986H176.919C175.599 69.3986 174.517 70.4917 174.517 71.8266V74.4763C174.517 75.368 174.999 76.1518 175.714 76.5739L164.042 86Z'
      fill='#66A4FF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M197.557 58H176.441C175.099 58 174 56.9804 174 55.7353V53.2647C174 52.0187 175.099 51 176.441 51H207L197.557 58Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M175.188 76C174.479 75.5882 174 74.8235 174 73.9537V71.3687C174 70.0664 175.073 69 176.383 69H184L175.188 76Z'
      fill='#E1EEFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M258 130C258.624 128.334 259.268 126.666 259.921 125C260.151 125.957 260.4 126.964 260.667 128.024C260.775 128.45 260.886 128.886 261 129.33H260.97C259.909 129.33 258.901 129.57 258 130Z'
      fill='#FEFCFB'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M255.517 143C254.768 142.227 254.227 141.439 254.076 140.839C253.966 140.408 253.985 140.14 254.073 139.787L254.404 138.662C254.533 138.209 254.668 137.754 254.818 137.295C255.616 134.776 256.483 132.245 257.393 129.712C258.309 129.256 259.332 129 260.411 129H260.441C260.837 130.61 261.271 132.331 261.747 134.164C261.8 134.369 261.854 134.578 261.908 134.787V134.786C262.251 136.099 262.614 137.467 263 138.899C261.349 139.954 259.637 140.939 257.866 141.851C257.088 142.252 256.303 142.636 255.517 143Z'
      fill='#9787FF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M238.867 25H198C198.703 24.6164 199.414 24.2451 200.136 23.8838C209.479 19.2131 219.39 17 229.148 17C234.866 17 240.53 17.759 246 19.2283L238.867 25Z'
      fill='#66A4FF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M168.916 109.905C168.209 108.317 167.572 106.718 167 105.105C168.814 106.041 170.861 106.585 173.025 106.621L168.916 109.905ZM226.73 40.026H220.44L226.73 35V40.026Z'
      fill='#FBFAF8'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M173.727 106.595C171.563 106.559 169.516 106.015 167.702 105.079C165.444 98.705 164.234 92.161 164 85.658L175.71 76.302C176.066 76.51 176.479 76.629 176.919 76.629H211.23L198.088 87.13H176.919C175.594 87.13 174.509 88.215 174.509 89.54V92.169C174.509 93.495 175.594 94.579 176.919 94.579H188.765L173.727 106.595ZM220.552 69.18H184.622L197.764 58.68H233.694L220.552 69.18ZM243.016 51.231H207.086L221.142 40H257.072L243.016 51.231Z'
      fill='#87B8FF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M233.73 58H198L207.27 51H243L233.73 58Z'
      fill='white'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M211.645 76H177.213C176.772 76 176.357 75.8882 176 75.6927L184.943 69H221L211.645 76Z'
      fill='white'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M188.511 94H176.453C175.104 94 174 92.9813 174 91.7353V89.2647C174 88.0196 175.104 87 176.453 87H198L188.511 94Z'
      fill='white'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M260 26H239L245.954 20C250.832 21.3956 255.548 23.4093 260 26Z'
      fill='#87B8FF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M246.412 106.524H195L210.041 94.506H232.542C233.869 94.506 234.952 93.422 234.952 92.096V89.467C234.952 88.142 233.869 87.057 232.542 87.057H219.363L232.506 76.556H253.128C254.453 76.556 255.537 75.472 255.537 74.147V71.517C255.537 70.192 254.453 69.107 253.128 69.107H241.828L254.97 58.607H288.71C289.035 58.607 289.345 58.542 289.628 58.424C291.09 61.994 292.214 65.631 293.012 69.293L270.778 87.057H246.005C244.679 87.057 243.595 88.142 243.595 89.467V92.096C243.595 93.422 244.679 94.506 246.005 94.506H261.454L246.412 106.524ZM286.124 51.158H264.292L278.257 40C281.212 43.376 283.855 47.102 286.124 51.158Z'
      fill='#87B8FF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M289.073 58H255L264.414 51H286.461C287.021 51.9313 287.558 52.8804 288.071 53.8483C288.769 55.1649 289.411 56.4908 290 57.828C289.714 57.9389 289.401 58 289.073 58Z'
      fill='white'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M253.594 76H233L242.309 69H253.594C254.917 69 256 70.0196 256 71.2647V73.7362C256 74.9813 254.917 76 253.594 76Z'
      fill='white'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M232.581 94H210L219.355 87H232.581C233.913 87 235 88.0196 235 89.2647V91.7353C235 92.9813 233.913 94 232.581 94Z'
      fill='white'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M261.739 94H246.394C245.077 94 244 92.9813 244 91.7353V89.2647C244 88.0196 245.077 87 246.394 87H271L261.739 94Z'
      fill='white'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M201.314 142.564C198.046 141.043 194.897 139.25 191.905 137.199H208.029L201.314 142.564ZM215.194 131.475H184.701C181.518 128.557 178.6 125.299 176 121.714L180.648 118H230.098C230.695 118 231.278 118.06 231.843 118.173L215.194 131.475Z'
      fill='#87B8FF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M207.951 137H192.088C189.609 135.19 187.238 133.187 185 131H215L207.951 137Z'
      fill='white'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M269.685 7.558C266.433 5.804 263.035 4.248 259.581 2.934L259.937 2C263.43 3.329 266.87 4.903 270.16 6.678L269.685 7.558ZM160.088 32.089L159.282 31.497C167.386 20.484 178.235 11.422 190.655 5.291L191.097 6.187C178.82 12.248 168.097 21.205 160.088 32.089ZM147.947 55.432L147 55.111C148.65 50.244 150.728 45.515 153.178 41.057L154.054 41.539C151.633 45.946 149.579 50.62 147.947 55.432Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M147.94 55L147 54.6874C148.637 49.9473 150.699 45.3417 153.131 41L154 41.4694C151.598 45.7615 149.559 50.3135 147.94 55Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M160.811 32L160 31.4035C168.151 20.3075 179.063 11.1772 191.555 5L192 5.90275C184.354 9.68404 177.308 14.5837 171.137 20.371C167.342 23.9296 163.878 27.8248 160.811 32Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M270.506 8C267.125 6.10651 263.591 4.42677 260 3.00828L260.37 2C264.002 3.43469 267.579 5.13386 271 7.05002L270.506 8Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M65.823 178.121C65.1 178.121 64.355 178.079 63.589 177.994C62.084 177.809 60.517 177.498 58.727 176.735C53.89 174.673 50.993 169.965 51 165.019C51.001 163.978 51.131 162.927 51.398 161.888C51.881 160.003 52.587 158.57 53.355 157.263C54.133 155.975 54.991 154.849 55.928 153.884C57.79 151.928 59.954 150.585 62.266 149.54C64.802 148.317 67.328 147.072 69.86 145.839C69.703 148.651 69.599 150.743 69.652 151.93C75.413 151.93 97.106 151.93 108.945 151.93C110.265 142.157 111.1 133.846 111.579 126.792C118.26 123.935 124.979 121.158 131.746 118.477C138.307 115.891 144.904 113.377 151.585 111.033C148.301 101.885 146.723 92.456 146.721 83.134C146.713 52.517 163.698 23.066 193.009 8.597C204.827 2.764 217.36 0 229.705 0C260.32 0 289.77 16.997 304.238 46.306C310.078 58.136 312.841 70.683 312.837 83.038C312.836 87.331 312.5 91.6 311.843 95.808C311.235 99.705 310.352 103.551 309.203 107.313C308.497 109.626 307.69 111.907 306.786 114.15C306.37 113.603 305.946 113.061 305.513 112.526L306.715 111.604C306.715 111.604 300.771 100.495 296.867 100.122C296.813 100.117 296.759 100.113 296.705 100.109C296.26 100.075 294.933 99.982 293.098 99.924C294.558 94.446 295.313 88.771 295.315 83.044C295.317 74.757 293.741 66.359 290.439 58.295C289.856 56.872 289.22 55.461 288.529 54.06C288.021 53.03 287.489 52.02 286.935 51.029C282.315 42.769 276.134 35.87 268.948 30.521C266.39 28.617 263.705 26.909 260.917 25.406C256.36 22.95 251.532 21.041 246.539 19.718C241.079 18.27 235.426 17.522 229.719 17.522C219.98 17.522 210.088 19.703 200.763 24.306C200.042 24.662 199.333 25.028 198.631 25.406C194.434 27.669 190.577 30.333 187.087 33.323C187.003 33.394 186.92 33.466 186.837 33.538C172.347 46.081 164.232 64.308 164.225 83.093C164.222 92.841 166.402 102.74 171.009 112.072C182.428 135.203 205.664 148.617 229.824 148.617C236.565 148.617 243.38 147.572 250.028 145.402C251.268 146.99 252.768 148.005 254.174 148.866C258.142 151.086 262.085 152.17 266.261 152.812L266.709 150.968C266.737 151.085 266.862 151.171 267.027 151.201C266.825 152.542 266.488 154.814 266.063 157.772C262.153 159.673 258.167 161.238 254.136 162.48C253.502 162.675 252.869 162.862 252.233 163.041C251.334 163.295 250.432 163.533 249.529 163.754C247.755 164.19 245.979 164.565 244.196 164.88C239.422 165.723 234.624 166.136 229.854 166.135C227.485 166.135 225.124 166.034 222.775 165.832C216.524 165.296 210.364 164.053 204.423 162.145C190.427 157.652 177.625 149.466 167.597 138.128C164.855 135.027 162.321 131.692 160.026 128.13C158.788 128.94 157.546 129.743 156.302 130.54C151.59 133.555 146.831 136.476 142.051 139.353C133.324 144.583 124.504 149.623 115.614 154.523C113.813 155.506 112.012 156.485 110.208 157.461C109.432 153.994 108.945 151.93 108.945 151.93H95.007C95.007 151.93 78.804 151.93 69.652 151.93C69.652 159.242 70.719 167.862 71.921 177.061C70.63 177.52 69.277 177.852 67.836 178.007C67.184 178.083 66.513 178.121 65.823 178.121ZM266.18 148.716C263.053 147.391 259.888 145.834 257.471 143.934C257.072 143.625 256.697 143.297 256.363 142.966C257.171 142.607 257.979 142.228 258.779 141.833C260.6 140.934 262.361 139.962 264.059 138.922C264.833 141.674 265.695 144.654 266.652 147.877L266.552 147.89C266.28 147.925 266.077 148.086 266.077 148.255C266.077 148.271 266.079 148.286 266.083 148.302L266.18 148.716ZM295.693 133.614C295.465 130.96 295.336 128.128 295.336 124.858C295.336 122.75 295.389 120.459 295.502 117.916C296.297 118.698 296.845 119.179 296.845 119.179L296.846 119.177L297.005 119.056L299.393 117.223C300.343 118.344 301.284 119.48 302.176 120.655C302.507 121.087 302.836 121.521 303.161 121.957C301.009 126.027 298.514 129.929 295.693 133.614Z'
      fill='#FDC748'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M81.6368 67C82.6793 72.3164 83.7187 82.0589 80 85.6064C80 85.6064 81.4529 91 91.3302 91C102.191 91 96.5206 85.6074 96.5206 85.6074C90.5934 84.1908 90.7457 79.7924 91.7782 75.6612L81.6368 67Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M75.8306 89C77.0379 87.0916 75 82.4706 75 82.4706C75 82.4706 93.0061 77.8804 100.363 84.9192C101.889 86.3791 100.194 88.5206 100.194 88.5206L75.8306 89Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M100.994 86C99.8427 85.8412 98.6303 85.7 97.4028 85.5978C95.422 85.4325 92.8772 85.3693 90.2124 85.3693C86.832 85.3693 83.2582 85.4715 80.3999 85.5969C78.9738 85.66 77.5315 85.7687 76.1492 85.9006C75.8998 84.1627 75 82.3255 75 82.3255C75 82.3255 80.7684 81 87.1088 81C91.9713 81 97.1697 81.7793 100.362 84.5315C100.836 84.9402 101 85.4074 101 85.8579C100.999 85.9062 100.998 85.9536 100.994 86Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M43.557 291.394C44.289 292.234 45.454 293.179 45.958 293.059C46.006 293.047 46.154 293.012 46.214 292.691C46.24 292.554 46.207 292.428 46.114 292.306C45.717 291.785 44.378 291.505 43.557 291.394ZM45.872 293.415C44.94 293.415 43.452 291.859 43.014 291.278L43 291.09L43.167 291C43.271 291.009 45.723 291.22 46.391 292.095C46.544 292.296 46.6 292.519 46.556 292.755C46.473 293.204 46.228 293.352 46.037 293.398L45.872 293.415Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M43.552 290.579C44.496 290.616 45.997 290.268 46.233 289.834C46.254 289.795 46.305 289.702 46.147 289.537C46.026 289.41 45.875 289.349 45.684 289.349H45.683C45.023 289.349 44.078 290.092 43.552 290.579ZM43.674 290.926C43.465 290.926 43.28 290.912 43.133 290.884L43 290.766L43.04 290.593C43.103 290.527 44.581 289 45.683 289H45.684C45.971 289.001 46.212 289.101 46.399 289.297C46.689 289.601 46.611 289.868 46.538 290.001C46.208 290.607 44.675 290.926 43.674 290.926Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M110.7 315.306C112.066 315.5 113.924 315.488 114.268 315.014C114.312 314.952 114.357 314.846 114.233 314.629C114.165 314.509 114.053 314.429 113.892 314.386C113.141 314.179 111.597 314.846 110.7 315.306ZM112.391 315.771C111.513 315.771 110.607 315.657 110.138 315.565L110 315.422L110.085 315.243C110.193 315.18 112.757 313.714 113.983 314.05C114.234 314.118 114.42 314.255 114.535 314.457C114.741 314.816 114.657 315.069 114.55 315.217C114.245 315.641 113.334 315.771 112.391 315.771Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M111.965 312.348C111.745 312.348 111.546 312.422 111.361 312.574C110.747 313.078 110.485 314.262 110.391 314.839C111.296 314.295 112.49 313.047 112.409 312.548C112.403 312.508 112.383 312.385 112.07 312.353L111.965 312.348ZM110.173 315.325L110.071 315.293L110 315.135C110.008 315.051 110.206 313.073 111.14 312.305C111.425 312.071 111.75 311.97 112.105 312.007C112.583 312.055 112.721 312.298 112.753 312.492C112.887 313.323 111.131 314.912 110.244 315.311L110.173 315.325Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M102 315H109.275L110 298H102.724L102 315Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M37 286.099L43.2363 290L57 278.902L50.7627 275L37 286.099Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M43.8094 289.3L37.4474 284.144C37.2162 283.956 36.8834 283.952 36.6482 284.135L31.4054 288.208C30.8612 288.629 30.8672 289.451 31.4093 289.875C33.6615 291.638 34.8474 292.384 37.6447 294.652C39.3658 296.048 43.646 300.3 46.0227 302.227C48.3477 304.113 50.6368 302.081 49.8375 301.081C46.2569 296.601 44.8109 292.764 44.4432 290.39C44.3764 289.961 44.1482 289.574 43.8094 289.3Z'
      fill='#20282E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M109.173 315H101.112C100.811 315 100.55 315.2 100.484 315.481L99.0266 321.735C98.8749 322.384 99.3913 322.999 100.088 322.987C102.995 322.94 107.197 322.777 110.852 322.777C115.126 322.777 118.816 323 123.828 323C126.857 323 127.699 320.08 126.43 319.814C120.656 318.611 115.941 318.482 110.951 315.548C110.409 315.229 109.81 315 109.173 315Z'
      fill='#20282E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M65.7424 88.8281C59.5096 91.8636 56 111.815 56 111.815L71.2308 118C71.2308 118 74.6583 109.741 76.6165 100.928C78.6687 91.6954 72.1151 85.7239 65.7424 88.8281Z'
      fill='#0A1629'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M73.2892 99.8522C69.494 103.784 67.759 111.488 67 116.498L70.6769 118C70.6769 118 74.0088 109.944 76 101.214C75.6747 99.0758 74.8664 98.2188 73.2892 99.8522Z'
      fill='#23273A'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M108.374 88.2925C108.374 88.2925 116.233 97.1528 108.81 152C96.9089 152 75.1015 152 69.3101 152C69.0387 145.948 72.8477 116.426 67 87.9123C67 87.9123 73.7705 86.5558 80.2224 86.2458C85.2698 86.003 92.5772 85.8424 97.0145 86.2468C102.864 86.7785 108.374 88.2925 108.374 88.2925Z'
      fill='#0A1629'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M110.979 109.463L104.57 98C103.331 104.279 102.804 108.162 103.065 114.35C103.239 118.288 106.719 132.87 109.827 135C110.805 124.281 111.085 115.932 110.979 109.463Z'
      fill='#23273A'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M112.827 96C113.794 100.809 114.815 105.729 115.864 110.563C116.913 115.409 118.015 120.234 119.29 124.915C119.62 126.067 119.927 127.25 120.29 128.365L120.554 129.213L120.686 129.638L120.64 129.586C120.564 129.5 120.486 129.491 120.545 129.58C120.623 129.778 121.244 130.207 122.051 130.516C122.869 130.832 123.869 131.111 124.928 131.323C129.216 132.14 134.267 132.258 139.06 132.244L140 137.617C138.673 138.04 137.434 138.352 136.134 138.653C134.846 138.957 133.546 139.219 132.224 139.419C129.582 139.828 126.879 140.089 123.994 139.972C122.548 139.912 121.051 139.774 119.447 139.381C117.851 138.968 116.085 138.408 114.236 136.959C113.333 136.236 112.437 135.236 111.797 134.018C111.634 133.726 111.494 133.387 111.372 133.102L110.824 131.698C110.318 130.444 109.903 129.208 109.449 127.962C107.775 122.99 106.39 118.029 105.158 113.044C103.946 108.043 102.883 103.086 102 97.9741L112.827 96Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M98.3233 93.8902C96.2856 100.7 104.547 121 104.547 121L121 116.735C121 116.735 120.368 106.189 116.621 97.8172C110.966 85.1888 100.768 85.7154 98.3233 93.8902Z'
      fill='#0A1629'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M138.744 133.213L147 133L143.029 141.987C143.029 141.987 139.671 142.455 136.911 137.707L134 134.079L137.348 133.376C137.807 133.279 138.274 133.224 138.744 133.213Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M152 134.649L147.366 142L143 141.869L146.892 133L152 134.649Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M110 298L109.611 307H102L102.389 298H110Z'
      fill='#ED975D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M49.918 275L56 279.057L49.082 285L43 280.944L49.918 275Z'
      fill='#ED975D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M82.0194 61.7504C82.4622 69.0768 82.3498 73.3872 86.0366 77.1501C91.5829 82.8114 100.605 79.4633 102.354 72.1531C103.93 65.5726 102.942 54.6968 95.7919 51.7766C88.7475 48.8976 81.5776 54.425 82.0194 61.7504Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M73.2316 60.3818C75.0519 66.9357 79.3397 74.4854 84.8813 74.9644C91.7683 75.5601 94.8767 68.5764 95.7823 61.3597C99.9111 58.586 97.7416 55.5387 101.882 55.1505C107.191 54.6526 105.497 45.1146 98.4983 43.5796C98.4983 43.5796 100.841 47.8764 95.9232 45.7092C91.0065 43.5411 86.1985 42.6106 80.8924 43.1499C80.8924 43.1499 87.1635 46.2268 81.0302 47.5999C74.8959 48.9729 73.0595 52.6919 75.8831 54.9351C75.8831 54.9351 72.0321 56.0671 73.2316 60.3818Z'
      fill='#233862'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M92.0078 63.1238C92.1281 65.0716 93.0626 66.9039 94.186 68.1026C95.8758 69.9053 97.6383 68.7832 97.9369 66.5861C98.2058 64.6097 97.651 61.2894 95.5857 60.2961C93.55 59.3171 91.8707 60.896 92.0078 63.1238Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M94.3066 152C94.3066 152 101.483 203.737 95.8289 224.464C86.8745 257.293 52.6132 285 52.6132 285L41 277.422C41 277.422 70.1713 254.023 73.743 226.547C76.951 201.863 68.8965 172.024 68.8965 152C78.0684 152 94.3066 152 94.3066 152Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M56.7247 282L45 274.396C53.0245 267.06 71.4749 248.103 74.2783 226.669C74.8146 222.564 75.0388 218.317 75.0388 213.996C75.0388 201.775 73.2503 188.965 71.686 177.117C70.4721 167.923 69.3946 159.308 69.3946 152C78.637 152 95 152 95 152H82.9916C82.9916 152 87.9915 167.586 92.2966 185.535C92.854 195.418 93.262 206.696 93.262 217.304C93.262 223.604 93.1186 229.666 92.7773 235.059C93.0802 234.373 93.3731 233.685 93.6559 232.992C88.659 245.237 80.6547 256.433 73.0645 265.291C68.0292 271.167 63.1758 276.013 59.5018 279.455C58.4768 280.416 57.5447 281.266 56.7247 282Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M95.494 227.519C95.498 227.507 95.502 227.494 95.506 227.481C95.501 227.495 95.498 227.506 95.494 227.519Z'
      fill='#2C5B99'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M95.348 227.984C95.451 227.661 95.553 227.34 95.652 227.016C95.553 227.34 95.452 227.661 95.348 227.984Z'
      fill='#2C5B99'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M95.4985 226.505C95.4995 226.502 95.5005 226.498 95.5015 226.495C95.5005 226.497 95.4995 226.503 95.4985 226.505Z'
      fill='#2C5B99'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M97.1105 221C97.4245 219.449 97.6815 217.775 97.8895 216C97.8895 216.002 97.8895 216.001 97.8895 216.003C97.7815 216.921 97.6605 217.815 97.5255 218.677C97.3995 219.477 97.2615 220.254 97.1105 221Z'
      fill='#2C5B99'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M97.272 180.972C93.9009 177.184 91 175 91 175C92.2204 191.697 93.2207 216.43 92.1104 234C93.6008 230.617 94.8612 227.135 95.8316 223.604C98.5824 213.543 98.2924 196.152 97.272 180.972Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M92.5074 235C92.8676 229.555 93.019 223.435 93.019 217.075C93.019 206.365 92.5884 194.978 92 185C94.6403 195.532 97.0332 206.871 98 216.393C97.6397 219.38 97.1398 222.097 96.4726 224.426C96.1602 225.511 95.8192 226.593 95.4525 227.667C95.1146 228.655 94.7554 229.636 94.3748 230.612C93.7993 232.09 93.1746 233.554 92.5074 235Z'
      fill='#2B73DF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M57 282.945L52.5527 286L40 277.42L43.9129 274L57 282.945Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M52.5527 286L40 277.42L43.9129 274L57 282.945L52.5527 286Z'
      fill='#264D90'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M109.01 152C109.01 152 120.153 198.994 120.938 221.443C121.818 246.618 112.988 306 112.988 306H100.456C100.456 306 98.9129 246.155 98.355 223.225C97.7478 198.225 83 152 83 152H109.01Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M100.341 301C99.9734 286.759 98.8203 242.043 98.3551 222.966C98.3057 220.957 98.1648 218.81 97.9472 216.56C97.0339 207.138 94.7731 195.92 92.2787 185.499C87.9858 167.569 83 152 83 152H109.01C109.01 152 120.153 198.823 120.939 221.19C120.98 222.378 121 223.643 121 224.974C121 225.434 120.998 225.903 120.993 226.379C120.889 237.052 119.633 251.524 118.147 265.17C117.613 270.064 117.05 274.852 116.501 279.32C116.177 281.943 115.858 284.454 115.553 286.814C115.542 286.896 115.531 286.982 115.52 287.064C114.8 292.616 114.153 297.298 113.693 300.549L100.341 301Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M115 301L114.309 306H99.4027L99 301.537L115 301Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M114.309 306H99.4027L99 301.537L115 301L114.309 306Z'
      fill='#264D90'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M300.316 107C301.181 107.8 301.852 108.481 302.568 109.245C303.263 109.993 303.944 110.747 304.608 111.514C305.932 113.047 307.163 114.647 308.353 116.273C310.753 119.511 312.855 122.96 314.709 126.529L315.086 127.256C315.264 127.612 315.416 127.981 315.543 128.356C315.795 129.107 315.939 129.877 315.984 130.616C316.068 132.103 315.808 133.445 315.432 134.624C314.667 136.992 313.445 138.842 312.181 140.548C309.542 143.891 306.614 146.596 303.264 149L300.737 146.141C301.931 144.779 303.163 143.308 304.264 141.839C305.39 140.376 306.426 138.866 307.278 137.338C308.154 135.838 308.833 134.269 309.12 132.92C309.261 132.248 309.272 131.651 309.183 131.218C309.143 131 309.083 130.821 309.007 130.666L308.879 130.445L308.545 129.912C306.593 126.765 304.477 123.719 302.2 120.798C301.071 119.33 299.866 117.922 298.659 116.529C298.059 115.83 297.443 115.147 296.823 114.476C296.211 113.83 295.539 113.116 295 112.581L300.316 107Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M301.404 145.31L294 144L297.869 151C297.869 151 302.637 150.822 304 147.832L301.404 145.31Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M288 146.909L291.403 152L297 150.285L293.274 144L288 146.909Z'
      fill='#E6776F'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M299.74 314.349L299.514 314.389C299.456 314.415 299.388 314.464 299.367 314.613C299.328 314.892 299.387 315.098 299.548 315.245C299.926 315.591 300.907 315.636 302.213 315.376C301.41 314.89 300.316 314.349 299.74 314.349ZM300.738 315.899C300.161 315.899 299.628 315.799 299.309 315.508C299.058 315.279 298.959 314.961 299.015 314.565C299.057 314.265 299.23 314.128 299.368 314.066C300.24 313.676 302.516 315.141 302.773 315.309L302.85 315.488L302.716 315.63C302.187 315.755 301.43 315.899 300.738 315.899Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M301.736 312.357L301.655 312.362C301.428 312.39 301.379 312.49 301.363 312.575C301.259 313.088 302.109 314.303 302.822 314.872C302.781 314.154 302.613 312.942 302.127 312.512C302.01 312.409 301.881 312.357 301.736 312.357ZM303.01 315.395L302.922 315.372C302.207 314.966 300.845 313.349 301.014 312.504C301.046 312.343 301.167 312.064 301.612 312.01C301.897 311.968 302.146 312.055 302.363 312.247C303.177 312.967 303.188 315.125 303.188 315.217L303.099 315.371L303.01 315.395Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M265.808 314.351C265.67 314.351 265.558 314.37 265.477 314.415C265.404 314.455 265.367 314.514 265.359 314.607C265.337 314.847 265.405 315.032 265.564 315.176C266.017 315.584 267.253 315.656 268.911 315.38C267.883 314.887 266.518 314.351 265.808 314.351ZM267.144 315.902C266.398 315.902 265.711 315.785 265.326 315.44C265.081 315.22 264.974 314.929 265.005 314.575C265.025 314.364 265.128 314.2 265.306 314.104C266.233 313.593 269.211 315.125 269.549 315.302L269.643 315.485L269.501 315.633C268.866 315.76 267.969 315.902 267.144 315.902Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M267.818 312.355L267.711 312.361C267.387 312.393 267.366 312.523 267.359 312.565C267.276 313.075 268.475 314.346 269.385 314.898C269.298 314.311 269.049 313.101 268.431 312.586C268.245 312.431 268.044 312.355 267.818 312.355ZM269.603 315.393L269.53 315.377C268.636 314.973 266.87 313.356 267.008 312.508C267.042 312.307 267.183 312.057 267.675 312.007C268.04 311.972 268.37 312.073 268.659 312.314C269.6 313.098 269.773 315.116 269.78 315.201L269.706 315.361L269.603 315.393Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M281.543 84C281.249 88.4962 280.445 97.6299 284 100.153C284 100.153 283.365 104.758 274.972 105.824C265.743 106.995 269.963 101.937 269.963 101.937C274.842 100.13 274.223 96.5193 272.886 93.2242L281.543 84Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M277 315H269.501L269 298H276.5L277 315Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M312 315H304.433L302 298H309.567L312 315Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M303.903 314H312.414C312.724 314 312.975 314.225 313.019 314.541L313.989 321.577C314.089 322.307 313.489 322.998 312.774 322.985C309.807 322.931 308.376 322.75 304.634 322.75C302.331 322.75 298.966 323 295.787 323C292.677 323 292.437 319.714 293.762 319.417C299.699 318.082 300.636 316.243 302.636 314.487C302.998 314.17 303.45 314 303.903 314Z'
      fill='#20282E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M269.083 314H277.443C277.747 314 277.994 314.225 278.037 314.541L278.989 321.577C279.088 322.307 278.498 322.998 277.796 322.985C274.881 322.931 273.477 322.75 269.801 322.75C267.539 322.75 262.861 323 259.737 323C256.682 323 256.448 319.714 257.748 319.417C263.579 318.082 265.874 316.243 267.839 314.487C268.193 314.17 268.638 314 269.083 314Z'
      fill='#20282E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M269 298L269.264 307H277L276.736 298H269Z'
      fill='#ED975D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M309.718 298H302L303.282 307H311L309.718 298Z'
      fill='#ED975D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M280.663 74.6965C281.172 82.1989 281.545 85.3641 278.336 89.676C273.51 96.1631 264.329 95.1569 261.623 87.9589C259.188 81.4809 258.765 70.2986 265.556 66.3841C272.246 62.5263 280.154 67.1931 280.663 74.6965Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M284.792 81.5915C288.935 83.9292 292 78.1629 292 78.1629C292 78.1629 284.585 78.9787 285.247 74.5067C286.127 68.5752 281.933 61.3626 271.411 62.2862C270.829 62.3375 270.266 62.4111 269.72 62.5027C267.681 61.6395 264.919 61.7312 263.178 64.0287C260.235 64.2805 256.175 67.8903 258.9 72.6524C258.9 72.6524 259.138 71.895 259.781 71.1738C260.004 73.9618 262.418 78.3936 265.419 78.6836C266.066 82.505 263.563 86.9277 264.452 90.9102C265.735 96.6614 275.305 98 275.305 98C274.257 95.215 275.866 93.5662 275.866 93.5662C282.371 96.5738 286.656 93.6357 286.656 93.6357C282.224 91.9567 283.563 88.9774 283.563 88.9774C289.501 91.2718 292 85.8721 292 85.8721C288.838 86.0393 286.168 84.2495 284.792 81.5915Z'
      fill='#233862'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M267.997 79.5356C268.046 81.0574 267.384 82.4597 266.511 83.3574C265.196 84.7094 263.592 83.7653 263.163 82.0341C262.778 80.4757 262.995 77.8942 264.697 77.1901C266.373 76.4968 267.943 77.7955 267.997 79.5356Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M275 148.898C275 148.898 276.882 198.135 281.338 227.051C284.939 250.407 300.905 305 300.905 305H311C311 305 302.68 252.276 300.853 229.176C296.229 170.721 308.225 158.173 296.936 146L275 148.898Z'
      fill='#0A1629'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M283.685 164.019C283.685 164.019 278.835 163.223 276 171.99C277.071 188.601 278.845 210.643 281.459 226.525C282.037 230.063 282.919 234.327 284 239C281.953 210.941 283.685 164.019 283.685 164.019Z'
      fill='#010205'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M266.938 149.885C266.938 149.885 258.53 204.377 259.021 227.182C259.53 250.902 268.226 305 268.226 305H278.342C278.342 305 276.741 252.288 277.635 228.993C278.611 203.595 289 147 289 147L266.938 149.885Z'
      fill='#0A1629'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M313 306H299.086L298 301L312.904 301.114L313 306Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M313 306H299.086L298 301L312.904 301.114L313 306Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M296.238 100.022C300.108 100.394 306 111.456 306 111.456L296.216 119C296.216 119 288.115 111.859 289.08 107.848C290.084 103.67 292.521 99.6656 296.238 100.022Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M296.343 119.07C296.343 119.07 295.795 118.589 295 117.807C295 117.806 295 117.805 295 117.804C295.792 118.583 296.339 119.064 296.344 119.068L296.343 119.07ZM296.503 118.947L297.074 118.508L295.336 111.994C295.58 108.475 295.919 104.52 296.365 100.013C296.365 100.013 296.309 100.008 296.203 100C296.257 100.004 296.311 100.008 296.365 100.013C300.269 100.386 306.213 111.495 306.213 111.495L305.011 112.417L296.503 118.947Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M293.345 104.365C293.345 104.365 291.777 103.904 290.288 104.018C289.769 105.103 289.37 106.303 289.08 107.522C288.111 111.652 296.271 119 296.271 119L297 118.426L293.345 104.365Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M296.296 119C296.296 119 295.768 118.524 295 117.749C295.078 115.966 295.185 114.059 295.324 112L297 118.446L296.296 119Z'
      fill='#264D90'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M263.755 114.939C260.928 122.12 257.949 129.409 255.581 136.606C255.428 137.056 255.29 137.502 255.158 137.947L254.821 139.051C254.731 139.398 254.712 139.66 254.824 140.083C255.044 140.927 256.085 142.152 257.393 143.167C260.04 145.255 263.593 146.926 267 148.331L266.111 152C261.969 151.361 258.058 150.283 254.123 148.074C252.219 146.904 250.14 145.449 248.784 142.646C248.121 141.264 247.839 139.498 248.091 137.905C248.118 137.705 248.159 137.513 248.195 137.318L248.289 136.906L248.464 136.149C248.579 135.643 248.699 135.14 248.83 134.65C249.849 130.691 251.09 126.897 252.425 123.139C253.748 119.372 255.165 115.689 256.743 112L263.755 114.939Z'
      fill='#FFB27D'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M257.403 105.58C257.403 105.58 254.026 107.291 266.821 150C278.797 148.432 291.173 146.811 297 146.049C294.887 133.822 293.882 126.244 296.454 100.247C296.454 100.247 289.951 99.6989 283.418 100.235C278.308 100.656 274.125 101.038 269.714 102.031C263.898 103.339 257.403 105.58 257.403 105.58Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M266.473 148C265.02 143.124 263.788 138.81 262.744 134.99L262.96 125.904L263.552 126.191C263.552 126.191 267.736 115.708 267.732 110.209C267.73 108.981 267.52 108.001 267.007 107.442C265.203 105.475 263.693 104.564 261.782 104.564C261.227 104.564 260.639 104.641 260 104.791C262.423 104.02 266.325 102.843 269.961 102.029C274.388 101.037 278.584 100.655 283.712 100.235C285.865 100.059 288.016 100 289.934 100C293.851 100 296.793 100.247 296.793 100.247C296.346 104.754 296.006 108.709 295.761 112.227C295.616 114.308 295.505 116.235 295.424 118.037C295.424 118.038 295.424 118.039 295.424 118.04C295.31 120.583 295.257 122.874 295.257 124.982C295.258 132.611 295.957 137.853 297 144.019L266.473 148Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M263 134C262.251 131.83 261.588 129.833 261 128C261.589 129.833 262.253 131.828 263 134Z'
      fill='#2C5B99'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M297.264 144.162L298.961 146.572C299.093 146.759 298.875 146.995 298.529 147.038L267.174 150.993C266.905 151.028 266.665 150.928 266.626 150.767L266.005 148.22C265.963 148.044 266.176 147.863 266.47 147.827L296.747 144.007C296.97 143.979 297.179 144.041 297.264 144.162Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M267.07 151C266.846 151 266.661 150.907 266.626 150.767L266.102 148.616L266.006 148.22C266.002 148.205 266 148.191 266 148.175C266 148.014 266.201 147.86 266.471 147.827L296.746 144.007C296.782 144.002 296.817 144 296.851 144C297.032 144 297.191 144.06 297.263 144.162L298.96 146.572C298.987 146.61 298.999 146.649 299 146.688C299.001 146.846 298.806 147.003 298.528 147.038L267.175 150.993C267.139 150.998 267.105 151 267.07 151Z'
      fill='#233862'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M293.051 147.996L293.775 147.886C293.919 147.865 294.018 147.764 293.997 147.661L293.251 144.151C293.23 144.049 293.094 143.983 292.95 144.004L292.226 144.113C292.082 144.135 291.981 144.236 292.003 144.339L292.749 147.848C292.771 147.95 292.906 148.017 293.051 147.996Z'
      fill='#0A1629'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M273.05 150.996L273.774 150.887C273.918 150.866 274.018 150.764 273.997 150.661L273.251 147.152C273.23 147.05 273.093 146.983 272.949 147.004L272.226 147.114C272.082 147.135 271.982 147.236 272.003 147.34L272.749 150.849C272.77 150.951 272.906 151.018 273.05 150.996Z'
      fill='#0A1629'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M259 119.765C259.814 123.702 260.99 128.688 262.637 135L263 119L259 119.765Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M262.779 135C261.654 130.783 260.738 127.143 260 124L263 125.486L262.779 134.999V135Z'
      fill='#2B73DF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M256.947 105.028C253.208 106.56 250 119.615 250 119.615L262.85 126C262.85 126 269.068 110.039 266.281 106.927C263.38 103.687 261.248 103.266 256.947 105.028Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M262.85 126L262.262 125.708L250 119.615C250 119.615 253.207 106.56 256.947 105.028C258.591 104.355 259.917 104 261.092 104C262.989 104 264.489 104.927 266.281 106.928C266.79 107.496 266.998 108.493 267 109.742C267.004 115.337 262.85 126 262.85 126Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M279.522 306H266.051L265 301L280 301.114L279.522 306Z'
      fill='#30619E'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M279.522 306H266.051L265 301L280 301.114L279.522 306Z'
      fill='#3F8CFF'
    />
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M267.13 147.599L266.111 147.131C265.012 146.627 263.84 147.653 264.018 148.964L264.756 154.403C264.913 155.561 265.98 156.292 266.963 155.887C267.3 155.748 267.651 155.545 267.988 155.25C268.688 154.638 269.039 153.649 268.997 152.658L268.901 150.404C268.849 149.165 268.159 148.071 267.13 147.599Z'
      fill='#FFB27D'
    />
  </svg>
)
